import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, ChevronDown, MessageCircle } from 'lucide-react';
export function Hero() {
  return <section className="relative min-h-screen flex items-center justify-center overflow-hidden" data-id="element-77">
      {/* Animated Gradient Background */}
      <div className="absolute inset-0 bg-gradient-to-br from-[#FF6B35] via-[#F7931E] to-[#FFE5D9] animate-gradient" data-id="element-78" />

      {/* Overlay for better text readability */}
      <div className="absolute inset-0 bg-white/10" data-id="element-79" />

      <div className="relative z-10 max-w-7xl mx-auto px-6 text-center" data-id="element-80">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} data-id="element-81">
          <span className="inline-block py-1 px-3 rounded-full bg-white/30 backdrop-blur-md border border-white/40 text-white text-sm font-bold tracking-wider mb-6 shadow-sm" data-id="element-82">
            NEXORA VIRTUAL AGENCY
          </span>

          <h1 className="text-5xl md:text-7xl lg:text-8xl font-extrabold text-white tracking-tight leading-tight mb-8 drop-shadow-sm" data-id="element-83">
            We Build Digital <br data-id="element-84" />
            Experiences That <br data-id="element-85" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-white to-orange-100" data-id="element-86">
              Move People
            </span>
          </h1>

          <p className="text-xl md:text-2xl text-white/90 max-w-2xl mx-auto mb-10 font-medium leading-relaxed" data-id="element-87">
            Nexora Virtual specializes in high-performance mobile apps and
            custom WordPress solutions that drive growth for your business.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-88">
            <motion.a href="https://wa.me/447921876472?text=Hi%20Nexora%20Virtual%2C%20I%27d%20like%20to%20start%20a%20project" target="_blank" rel="noopener noreferrer" whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} className="w-full sm:w-auto px-8 py-4 bg-white text-[#FF6B35] font-bold text-lg rounded-full shadow-xl hover:shadow-2xl transition-all flex items-center justify-center gap-2" data-id="element-89">
              Start Your Project
              <MessageCircle size={20} data-id="element-90" />
            </motion.a>

            <motion.a href="#services" whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} className="w-full sm:w-auto px-8 py-4 bg-transparent border-2 border-white text-white font-bold text-lg rounded-full hover:bg-white/10 transition-all backdrop-blur-sm" data-id="element-91">
              View Our Services
            </motion.a>
          </div>
        </motion.div>
      </div>

      {/* Scroll Indicator */}
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1,
      y: [0, 10, 0]
    }} transition={{
      delay: 1,
      duration: 2,
      repeat: Infinity
    }} className="absolute bottom-10 left-1/2 -translate-x-1/2 text-white/80" data-id="element-92">
        <ChevronDown size={32} data-id="element-93" />
      </motion.div>
    </section>;
}